import { Outlet, useLocation } from 'react-router'
import { motion } from 'framer-motion'
import useHelmet from '../../utilities/hooks/helmet/useHelmet'
const AuthLayout = () => {
    const { pathname } = useLocation()
    useHelmet('ورود به حساب کاربری')

    return (
        <div className="sm:w-full md:px-[35%] relative md:bg-bg-md-screen">
            <motion.div
                key={pathname}
                initial={{ opacity: 0, x: '100%' }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: '-100%' }}
                transition={{ duration: 0.2 }}
                className="w-100 vh-100"
            >
                <div className=" bg-white">
                    <Outlet />
                </div>
            </motion.div>
        </div>
    )
}

export default AuthLayout
